'Modify'.page()
'Modify Profitori'.title()
'Back'.action({act: 'cancel'})
'Modify Built-in Specs'.action({spec: "ModifyBuiltInSpecs.js"})
'Extension Specs'.action({spec: "ExtensionList.js"})
